// Following strong recommendation from: https://webpack.js.org/concepts/module-federation/#troubleshooting
// import '@cld/env-config';
import { getEnvironmentFromHost } from './utils/getEnvironmentFromHost';

window.environmentFromHost = getEnvironmentFromHost(window.location.host);
void import('./bootstrap');
